import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import PC from './PC'
import Wx from './Wx'
import JD from './JD'

import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import qs from 'qs'
import wx from 'weixin-js-sdk'
import storage from './commons/common.js'
import weChat from './commons/wechat.js'
import router from './router'
import weui from 'weui.js'
import 'weui'
import moment from "moment"
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import $ from 'jquery'
import { md5 } from 'js-md5'  // 1. 引入 md5

Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.component("pc", PC)
Vue.component("wx", Wx)
Vue.component('jd', JD);
Vue.component('icon', Icon)

Vue.prototype.$axios = axios;
Vue.prototype.qs = qs;
Vue.config.productionTip = false;
Vue.use(ElementUI);

// ==========================================
// 等保整改：axios 请求签名鉴权
// ==================================

// 2. 从环境变量读取（推荐），如果没有则先用默认值或空字符串
const APP_ID = 'webApp' || ''
const APP_SECRET = 'webApp' || ''

console.log('看下ID和密钥', APP_ID, APP_SECRET)

// 如果未配置，在控制台提醒
if (!APP_ID || !APP_SECRET) {
  console.warn('[鉴权配置] 未检测到 VUE_APP_ID 或 VUE_APP_SECRET，请检查 .env 文件配置')
}

axios.interceptors.request.use(
  config => {
    console.log('响应拦截器的config', config)
    const timestamp = Date.now()

    // let url = config.url;
    let url = (config.url || '').replace(/^\/+/, '').replace(/\/+$/, '')

    const signStr = `${APP_ID}${APP_SECRET}${timestamp}/${url}`

    console.log('signStr', signStr)

    const sign = md5(signStr)
    // .toUpperCase()


    config.headers['X-App-Id'] = APP_ID
    config.headers['X-Timestamp'] = timestamp
    config.headers['X-Sign'] = sign

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 4. 响应拦截器：统一处理鉴权失败（可选，建议加上）
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      console.error('[鉴权失败] 签名验证未通过，请检查 appId/secret 及签名规则是否一致')
      // 这里可以统一提示，比如：
      Vue.prototype.$message.error('请求鉴权失败，请联系管理员')
    }
    return Promise.reject(error)
  }
)

// ==========================================
// 原有 axios 配置不变
// ==========================================

// 生产环境
axios.defaults.baseURL = 'https://shop.byh365.cn/prod-api/api-business'

// 测试环境
// axios.defaults.baseURL = 'http://shop.byh365.net/prod-api/api-business'


axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers['X-Tenant-Id'] = 1;

Vue.prototype.$storage = storage;
Vue.prototype.$wx = wx;
Vue.prototype.$weChat = weChat;
Vue.prototype.$weui = weui;
Vue.prototype.$moment = moment

new Vue({
    el: '#app',
    router,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js